function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#7B8B99",
  fillRule: "evenodd",
  d: "M8 16a8 8 0 118-8 8 8 0 01-8 8zM8 1.333a6.667 6.667 0 00-6.633 6h8.357L7.195 4.81a.667.667 0 01.944-.943l3.674 3.668a.666.666 0 010 .943L8.14 12.145a.667.667 0 11-.944-.943l2.54-2.535H1.367A6.667 6.667 0 108 1.333z"
});

var SvgGo = function SvgGo(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgGo;